import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import * as actions from "redux/actions/balanceActions";
import MiniLoader from "components/MiniLoader";
import { Translate } from "react-redux-i18n";

const Table_ = (props) => {
  const onClickLoadMore = () => {
    if (props.loadingMore || !props.hasMore) return;
    props.loadMore(
      {
        index: props.list.length,
        id: props.user_id,
        search: props.search,
        kind: props.kind,
      },
      props.token
    );
  };

  return (
    <div className="balance-table-wrapper">
      <div className="balance-scroll">
        <table className="table table-hover balance-table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Kind</th>
              <th>Description</th>
              <th className="text-end">Credit</th>
              <th className="text-end">Debit</th>
              <th className="text-end">Balance</th>
              <th className="text-end">Created Date</th>
            </tr>
          </thead>
          <tbody>
            {props.list.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.kind_transaction}</td>
                <td>{item.description}</td>
                <td className={Number(item.value) >= 0 ? "text-success text-end" : "text-danger text-end"}>
                  {Number(item.value) >= 0 && '+ ' + Number(item.value).toFixed(2)}
                </td>
                <td className={Number(item.value) >= 0 ? "text-success text-end" : "text-danger text-end"}>
                  {Number(item.value) <= 0 && "- " + Math.abs(Number(item.value)).toFixed(2)}
                </td>
                <td className="text-end">
                  <strong>{Number(item.balance).toFixed(2)}</strong>
                </td>
                <td className="text-end">
                  {moment(item.created_at).zone("+00:00").format("DD/MM/YYYY")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="balance-table-footer">
        {props.loading && props.list.length === 0 ? (
          <MiniLoader />
        ) : props.hasMore && (
          props.loadingMore ? (
            <MiniLoader />
          ) : (
            <button type="button" className="btn btn-primary btn-sm" onClick={onClickLoadMore}>
              <Translate value="load_more" />
            </button>
          )
        )}
      </div>
    </div>
  );
};

Table_.propTypes = {
  list: PropTypes.array.isRequired,
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,
    list: reducer.balance.list,
    error: reducer.balance.error,
    loading: reducer.balance.loading,
    search: reducer.balance.search,
    kind: reducer.balance.kind,
    loadingMore: reducer.balance.loadingMore,
    hasMore: reducer.balance.has_more,
  };
}

const mapDispatchToProps = dispatch => ({
  loadMore: (params, token) =>
    dispatch(actions.loadListScroll({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Table_);
